import React from 'react';

const founders = [
  {
    name: 'Ranyl Bantog',
    role: 'Platform & Infrastructure',
    description: 'Built the infrastructure automation, orchestration engine, and developer platform. Designed the system to provision, test, and scale AI agents autonomously.',
    email: 'ranyl.bantog@remote-assistant.ai',
    icon: 'fa-server',
  },
  {
    name: 'Daniel Klein',
    role: 'Product, Enterprise Sales & Go-to-Market',
    description: 'Built the consumer product on the platform. Validates the infrastructure by shipping a real SaaS product to real businesses on top of it.',
    email: 'daniel.klein@remote-assistant.ai',
    icon: 'fa-rocket',
  },
];

const About = () => {
  return (
    <div className="px-8 py-20 bg-neutral-800">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
            Who We Are
          </h2>
          <p className="!text-stone-300 text-lg font-medium font-['Inter'] max-w-2xl mx-auto">
            Built by operators, not a sales team. Two founders — one builds the infrastructure, the other builds the product that runs on it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {founders.map((founder) => (
            <div key={founder.name} className="bg-neutral-900 border border-neutral-700 rounded-lg p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-[#055EFD]/20 rounded-full flex items-center justify-center">
                  <i className={`fa ${founder.icon} text-[#0AF1FE] text-xl`}></i>
                </div>
                <div>
                  <h3 className="!text-white text-lg font-bold font-['Montserrat']">{founder.name}</h3>
                  <span className="text-[#0AF1FE] text-xs font-bold font-['Inter'] uppercase tracking-wider">{founder.role}</span>
                </div>
              </div>
              <p className="!text-stone-300 text-sm font-['Inter'] leading-relaxed mb-3">{founder.description}</p>
              <a href={`mailto:${founder.email}`} className="text-[#0AF1FE] hover:text-white text-xs font-medium font-['Inter'] transition-colors">
                <i className="fa fa-envelope text-[10px] mr-1"></i>{founder.email}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
